getPmSectionProcessing